<template>
  <div class="civii-messages-container">
    <div class="civii-message left">
      <div class="civii-message-content select-tramite">
          <label>{{titulo}}</label>
          <div class="input-group">
            <select v-model="opcionSeleccionada" :disabled="disabilitarItem" class="form-control">
              <option :value="null" selected disabled>Selecione uma opção</option>
              <option v-for="(opcion, index) in opciones" :value="opcion" :key="index">{{opcion[propiedadNombre]}}</option>
            </select>
            <div class="input-group-append">
                <button class="button button-primary" v-if="mostrarItem" @click="seleccionarDato">Prosseguir</button>
            </div>
          </div>  
        </div>
    </div>
  </div>
</template>

<style scoped>
 .select-tramite .input-group > select{
  position: relative;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
    margin-bottom: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
.select-tramite .input-group .button{
    display: inline-block;
    font-weight: 400;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: var(--secondary);
    border: 1px solid var(--secondary);
    padding: .375rem .75rem;
    font-size: 1rem;
    cursor: pointer;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.button.button-primary{
  border-top-right-radius: 25px !important;
  border-bottom-right-radius: 25px !important;
}
.button-primary:hover {
    background-color: var(--secondary-dark);
    border-color: var(--secondary-dark);
}

.select-tramite .input-group{
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: 100%;
  margin-top: .5rem;
}
.select-tramite .input-group-append {
    margin-left: -1px;
}
.select-tramite .form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    outline: 0;
}
</style>


<script>
import { mapActions } from 'vuex';
export default {
    props: {
        titulo: {
            type: String,
        },
        opciones: {
            type: Array,
        },
        propiedadId:{
            type: String,
        },
        propiedadNombre:{
            type: String,
        },
        fechaBloqueo: {
            type: Number
        }
    },
    methods: {
        ...mapActions(["sendMessage"]),
        seleccionarDato() {
            if (this.opcionSeleccionada != null) {
                sessionStorage.setItem(this.propiedadId, JSON.stringify(this.opcionSeleccionada));
                this.disabilitarItem = true;
                this.mostrarItem = false;
                this.sendMessage({message: this.opcionSeleccionada[this.propiedadNombre], token: "token"})
            }
        },
    },
    data: function () {
        return {
            opcionSeleccionada: null,
            mostrarItem: true,
            disabilitarItem: false
        };
    },
    created: function() {
        if(this.fechaBloqueo < new Date().getTime() ) {
            this.disabilitarItem = true;
            this.mostrarItem = false;
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/answers/Select/Select.vue